import { useEffect, useState } from "react";
import { Barometer } from "../../types";
import { config } from "../config";

interface Props {
  uuid: string | undefined;
}

export function useBarometer({ uuid }: Props) {
  const [barometer, setBarometer] = useState<Barometer | undefined>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    fetchBarometer(uuid).then(setBarometer);

    setIsLoading(false);
  }, [uuid]);

  return {
    barometer,
    isLoading,
  };
}

const fetchBarometer = async (
  uuid: string | undefined
): Promise<Barometer | undefined> => {
  try {
    const response = await fetch(config.urls.base + uuid, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    }).catch((err) => {
      throw new Error(err);
    });

    if (!response) {
      throw new Error("No response");
    }

    const json = await response.json();

    if (!json.id) {
      throw new Error(
        "Error getting Evidence Barometer, something seems wrong with the returned type"
      );
    }

    json.evidence_level = json.evidence_level ?? 1;
    json.peer_reviewed = json.peer_reviewed ?? false; 

    return json as Barometer;
  } catch (e) {
    console.warn("Error getting Evidence Barometer: ", e);
  }
};
